<template>
  <div class="AppointmentGmail">
    <a class="send-button" @click="showModal">Gmail</a>
    <component-modal v-show="condition.condition" transition="expand">

      <template slot="title">
        Gmail
      </template>

      <div slot="body" class="wrapper">
        <input type="text" v-model="search.user" @keyup="searchTable()" placeholder="送信対象者検索">
        <div class="mail-list">
          <table-c>
            <tr-c slot="tr-th" @click.native="push(list)" v-for="list in filteredUsers" :key="list.id" class="tr_hover">
              <td-c>{{list.user}} {{list.email}}</td-c>
            </tr-c>
          </table-c>
        </div>
        <input type="text" v-model="sendUser" placeholder="送信対象者">
      </div>

      <div class="footer" slot="footer">
        <btn @click.native="send">送信画面</btn>
        <btn @click.native="showModal">キャンセル</btn>
      </div>

    </component-modal>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/users/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  pageName: 'user',
  pageNames: 'users'
}

export default {
  props: {
    appointment: Object
  },
  name: 'AppointmentGmail',
  data () {
    return {
      condition: {
        condition: false
      },

      sendUser: [],

      user: {
        email: ''
      },

      watch: {
        user: ''
      },

      search: {
        user: ''
      }
    }
  },

  computed: {
    state () {
      return this.$store.getters['appointments/state']
    },

    support () {
      return this.$store.getters['appointments/support']
    },

    result () {
      return this.$store.getters['appointments/result']
    },

    ap_type () {
      return this.$store.getters['appointments/ap_type']
    },

    medium () {
      return this.$store.getters['appointments/medium']
    },

    shop_type () {
      return this.$store.getters['appointments/shop_type']
    },

    hp_type () {
      return this.$store.getters['appointments/hp_type']
    },

    hp_browse () {
      return this.$store.getters['appointments/hp_browse']
    },

    gender () {
      return this.$store.getters['appointments/gender']
    },

    school_type () {
      return this.$store.getters['appointments/school_type']
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    contact_method () {
      return this.$store.getters['appointments/contact_method']
    },

    contact_person () {
      return this.$store.getters['appointments/contact_person']
    },

    parking () {
      return this.$store.getters['appointments/parking']
    },

    learning_result () {
      return this.$store.getters['appointments/learning_result']
    },

    learning_continuation () {
      return this.$store.getters['appointments/learning_continuation']
    },

    fathers_involvement () {
      return this.$store.getters['appointments/fathers_involvement']
    },

    sending_method () {
      return this.$store.getters['appointments/sending_method']
    },

    users () {
      return this.$store.getters.users
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    offices () {
      return this.$store.getters.offices.reverse()
    },

    filteredUsers () {
      let self = this
      return self.users.filter((user) => {
        if (user.id !== 0) {
          return user.hide_flag === 0
        }
      })
    }
  },
  watch: {
    'watch.user': function (now, old) {
      // console.log(now)
      if (now) {
        this.user.email = now.email
      }
    }
  },
  methods: {
    showModal () {
      this.condition.condition = !this.condition.condition
    },

    push (list) {
      this.sendUser.push(list.email)
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },
    send () {
      // let id = 'ID : ' + this.appointment.id
      let state = '状態 : ' + this.state[this.appointment.state].name
      let office_id = '営業所 : ' + this.offices[this.appointment.office_id].name
      let contact_date = '問い合わせ日 : ' + this.appointment.contact_date
      let support = 'AP結果 : ' + this.support[this.appointment.support].name
      let result = '営業結果 : ' + this.result[this.appointment.result].name
      let acquisition_date = '取得日 : ' + this.appointment.acquisition_date
      let ap_type = 'AP種類 : ' + this.ap_type[this.appointment.ap_type].name
      let medium1 = '媒体1 : ' + this.medium[this.appointment.medium1].name
      let medium2 = '媒体2 : ' + this.medium[this.appointment.medium2].name
      let medium3 = '媒体3 : ' + this.medium[this.appointment.medium3].name
      let hp_type = 'HP種類 : ' + this.hp_type[this.appointment.hp_type].name
      let memo = 'APメモ : ' + this.appointment.memo
      let dm = 'DM届いた月 : ' + this.appointment.dm
      let shop_type = '店種類 : ' + this.shop_type[this.appointment.shop_type].name
      let shop_name = '店名 : ' + this.appointment.shop_name
      let contact_method = 'AP連絡方法 : ' + this.contact_method[this.appointment.contact_method].name
      let hp_browse = 'HP閲覧 : ' + this.hp_browse[this.appointment.hp_browse].name
      let visit_date = '訪問日 : ' + this.appointment.visit_date
      let visit_time = '訪問時間 : ' + this.appointment.visit_time
      let person = 'AP対応者 : ' + this.appointment.person
      let contact_person = '話した相手 : ' + this.contact_person[this.appointment.contact_person].name
      // let family_id = 'Family ID : ' + this.appointment.family_id
      let name = '名前 : ' + this.appointment.f_name + ' ' + this.appointment.l_name
      let kana = 'かな : ' + this.appointment.f_name_kana + ' ' + this.appointment.l_name_kana
      let zip = '郵便番号 : ' + this.appointment.zip
      let address = '住所 : ' + this.prefs[this.appointment.pref].name + ' ' + this.appointment.address1 + ' ' + this.appointment.address2
      let tel1 = '携帯TEL : ' + this.appointment.tel1
      let tel2 = '固定TEL : ' + this.appointment.tel2
      let fax = 'FAX : ' + this.appointment.fax
      let mail = 'MAIL : ' + this.appointment.mail
      let school_type = '学年 : ' + this.school_type[this.appointment.school_type].name + ' ' + this.appointment.school_name + ' ' + this.school_stage[this.appointment.school_stage].name + this.grade[this.appointment.grade].name
      let gender = '性別 : ' + this.gender[this.appointment.gender].name
      let sub_name = 'サブ名前 : ' + this.appointment.sub_f_name + ' ' + this.appointment.sub_l_name
      let sub_kana = 'サブかな : ' + this.appointment.sub_f_name_kana + ' ' + this.appointment.sub_l_name_kana
      let sub_school_type = 'サブ学年 : ' + this.school_type[this.appointment.sub_school_type].name + ' ' + this.appointment.sub_school_name + ' ' + this.school_stage[this.appointment.sub_school_stage].name + this.grade[this.appointment.sub_grade].name
      let sub_gender = 'サブ性別 : ' + this.gender[this.appointment.sub_gender].name
      let parking = '駐車場 : ' + this.parking[this.appointment.parking].name
      let parking_note = '駐車場備考 : ' + this.appointment.parking_note
      let achievement = 'メイン成績 : ' + this.appointment.achievement
      let learning = 'メイン習い事 : ' + this.appointment.learning
      let learning_start_period = 'メイン習い事いつから : ' + this.appointment.learning_start_period
      let learning_nervous = 'メイン習い事きっかけ : ' + this.appointment.learning_nervous
      let learning_result = 'メイン習い事成果 : ' + this.learning_result[this.appointment.learning_result].name
      let learning_continuation = 'メイン習い事継続 : ' + this.learning_continuation[this.appointment.learning_continuation].name
      let sub_achievement = 'サブ成績 : ' + this.appointment.sub_achievement
      let sub_learning = 'サブ習い事 : ' + this.appointment.sub_learning
      let sub_learning_start_period = 'サブ習い事いつから : ' + this.appointment.sub_learning_start_period
      let sub_learning_nervous = 'サブ習い事きっかけ : ' + this.appointment.sub_learning_nervous
      let sub_learning_result = 'サブ習い事成果 : ' + this.learning_result[this.appointment.sub_learning_result].name
      let sub_learning_continuation = 'サブ習い事継続 : ' + this.learning_continuation[this.appointment.sub_learning_continuation].name
      let attended = '当日の同席者 : ' + this.appointment.attended
      let fathers_involvement = '父親の絡み : ' + this.fathers_involvement[this.appointment.fathers_involvement].name
      let notices = '特記事項 : ' + this.appointment.notices
      let sending_products = '送るもの : ' + this.appointment.sending_products
      let sending_method = '送る方法 : ' + this.sending_method[this.appointment.sending_method].name
      let sending_date = '郵送・FAX / 予定日 : ' + this.appointment.sending_date
      let sending_time = '送信時間 : ' + this.appointment.sending_time
      let note = '備考 : ' + this.appointment.note
      // console.log('send')

      let url = 'https://mail.google.com/mail/?view=cm&to=' +
        // this.user.email +
        this.sendUser +

        '&su=' +
        'APカード / ' + visit_date + ' ' + visit_time +

        '&body=' +
        // id + '%0D%0A' +
        state + '%0D%0A' +
        office_id + '%0D%0A' +
        contact_date + '%0D%0A' +
        support + '%0D%0A' +
        result + '%0D%0A' +
        acquisition_date + '%0D%0A' +
        ap_type + '%0D%0A' +
        medium1 + '%0D%0A' +
        medium2 + '%0D%0A' +
        medium3 + '%0D%0A' +
        hp_type + '%0D%0A' +
        memo + '%0D%0A' +
        dm + '%0D%0A' +
        shop_type + '%0D%0A' +
        shop_name + '%0D%0A' +
        contact_method + '%0D%0A' +
        hp_browse + '%0D%0A' +
        visit_date + '%0D%0A' +
        visit_time + '%0D%0A' +
        person + '%0D%0A' +
        contact_person + '%0D%0A' +
        // family_id + '%0D%0A' +
        name + '%0D%0A' +
        kana + '%0D%0A' +
        zip + '%0D%0A' +
        address + '%0D%0A' +
        tel1 + '%0D%0A' +
        tel2 + '%0D%0A' +
        fax + '%0D%0A' +
        mail + '%0D%0A' +
        school_type + '%0D%0A' +
        gender + '%0D%0A' +
        sub_name + '%0D%0A' +
        sub_kana + '%0D%0A' +
        sub_school_type + '%0D%0A' +
        sub_gender + '%0D%0A' +
        parking + '%0D%0A' +
        parking_note + '%0D%0A' +
        achievement + '%0D%0A' +
        learning + '%0D%0A' +
        learning_start_period + '%0D%0A' +
        learning_nervous + '%0D%0A' +
        learning_result + '%0D%0A' +
        learning_continuation + '%0D%0A' +
        sub_achievement + '%0D%0A' +
        sub_learning + '%0D%0A' +
        sub_learning_start_period + '%0D%0A' +
        sub_learning_nervous + '%0D%0A' +
        sub_learning_result + '%0D%0A' +
        sub_learning_continuation + '%0D%0A' +
        attended + '%0D%0A' +
        fathers_involvement + '%0D%0A' +
        notices + '%0D%0A' +
        sending_products + '%0D%0A' +
        sending_method + '%0D%0A' +
        sending_date + '%0D%0A' +
        sending_time + '%0D%0A' +
        note.replace(/\n/g, '%0D%0A')
      window.open(url, '_blank', 'width=800,height=600')
    }
  }
}
</script>

<style lang='scss' scoped>
.send-button {
  cursor: pointer;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  flex-flow: column;
  /* border-top: solid 1px #ccc; */
  max-height: 340px;
}
.mail-list {
  overflow: scroll;
  margin: 5px 0;
}
.table {
  margin: 0;
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentGmail.vue?13ce8db4